// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__n3BCs","info":"Alert_info__GYDhm","success":"Alert_success__3rHPW","warning":"Alert_warning__ckE6e","error":"Alert_error__RbJ-Q"};